var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5765 6.82634C14.7303 8.87658 14.6876 9.69466 14.4491 11.7368C14.28 13.1809 13.1198 14.3128 11.6835 14.4741C9.23532 14.7455 6.76463 14.7455 4.31644 14.4741C2.87937 14.3128 1.71917 13.1809 1.55084 11.7368C1.26105 9.25333 1.26105 6.7446 1.55084 4.26116C1.71917 2.81622 2.88015 1.68512 4.31644 1.52387C6.76463 1.25246 9.23532 1.25246 11.6835 1.52387M14.4491 2.66667L7.99579 9.55576L5.26638 6.82634",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a628e0ca4685d3c9235c068eeaf59b58.svg";
export { ForwardRef as ReactComponent };